import React, { useState, useCallback, useMemo } from "react";
import {
  Grid,
  Box,
  Button,
  makeStyles,
  LinearProgress,
  Typography,
} from "@material-ui/core";
import _ from "lodash";
import { yellow } from "@material-ui/core/colors";
import ClearIcon from "@material-ui/icons/Clear";
import currencyJS from "currency.js";
import MaterialTable from "material-table";
import Swal from "sweetalert2";
import { useEffect } from "react";
import ItemFormComponent from "src/components/forms/ItemFormComponent";
import ProductItemModal from "src/components/modals/ProductItemModal";
import { useSelector, useDispatch } from "react-redux";
import LocalAtmIcon from "@material-ui/icons/LocalAtm";
import {
  fetchCurrencies,
  findAllDepartment,
  findAllBrand,
} from "src/redux/actions/reference.action";
import {
  addProduct,
  deleteProduct,
  getPurchaseExpense,
  addSupplier,
  getPurchaseDetails,
} from "src/redux/actions/purchaseRequest.action";
import { priceFormat, priceNumberFormat } from "src/utils/Number";
import { Alert, AlertTitle } from "@material-ui/lab";

import ExpenseModalComponent from "src/components/modals/ExpenseModalComponent";

import SupplierModal from "src/components/modals/SupplierModal";
import { useHistory } from "react-router-dom";
import { isAllowed } from "src/utils/Auth";
import { getAllProjects } from "src/redux/actions/product.action";

const useStyles = makeStyles((theme) => ({
  buttonAddExpense: {
    backgroundColor: yellow[500],
  },
}));

const actionTableAllow = {
  actionsColumnIndex: -1,
};

const actionTableNotAllow = {
  actionsColumnIndex: -5,
};

const PurchaseItemTableComponent = ({
  headerId,
  status,
  updateStatus,
  departid,
  brandid,
  companyid,
  year,
  headerData,
}) => {
  const classes = useStyles();

  const [actualBudgetBalance, setActualBudgetBalance] = useState(0);
  const { authorizePR } = useSelector((state) => state.authorizationReducer);
  const history = useHistory();

  const dispatch = useDispatch();

  const { products } = useSelector((state) => state.productReducer);
  const { allDepartments, allBrands } = useSelector(
    (state) => state.referenceReducer
  );
  const {
    purchaseRequest,
    purchaseRequestDetails,
    purchaseRequesteExpense,
    productAdd,
  } = useSelector((state) => state.purchaseRequestReducer);

  const {
    result: { country, currencyid, email, countryid },
  } = useSelector((state) => state.loginReducer);

  const { projects } = useSelector((state) => state.productReducer);

  const { currencies } = useSelector((state) => state.referenceReducer);

  useEffect(() => {
    dispatch(findAllDepartment());
    dispatch(findAllBrand());
    return () => {};
  }, []);

  const [openModal, setOpenModal] = useState(false);
  const [openSupploerModal, setOpenSupploerModal] = useState(false);

  const [detailId, setDetailId] = useState(null);

  const [productItems, setProductItems] = useState({
    PRHIDX: null,
    CURR_ID: null,
    PRDIDX: null,
    ITEMS_DETAIL: null,
    SKUIDX: null,
    PRICE: null,
    QTY: null,
    PR_UNIT: null,
    EXC_RATE: null,
    AMOUNT: null,
    OLD_AMOUNT: null,
    DF_AMT_THB: null,
    DF_PRICE_THB: null,
    BGIDX: null,
    REMARK: null,
    PR_BRANDID: null,
    PR_DEPARTID: null,
    BUDGETP_CODE: null,
    BUDGETP_NAME: null,
  });

  const [formState, setFormState] = useState("Add");
  const [openExpenseModal, setOpenExpenseModal] = useState(false);

  useEffect(() => {
    dispatch(getPurchaseDetails(headerId));
    dispatch(getPurchaseExpense(headerId));
    dispatch(fetchCurrencies(currencyid));
    renderLookupCurrencise();
    setActualBudgetBalance(0);

    if (productAdd.isRejected) {
      setProductItems({
        ...productItems,
        CURR_ID: null,
        PRDIDX: null,
        PRICE: null,
        QTY: null,
        PR_UNIT: null,
        EXC_RATE: null,
        AMOUNT: null,
        OLD_AMOUNT: null,
        DF_AMT_THB: null,
        DF_PRICE_THB: null,
        REMARK: null,
        PR_BRANDID: null,
        PR_DEPARTID: null,
        D_LOC_NAME: null,
        D_LOC: null,
        D_LOC_CODE: null,
        BUDGETP_CODE: null,
        BUDGETP_NAME: null,
      });
    }

    if (productAdd.isSuccess) {
      setProductItems({
        PRHIDX: null,
        CURR_ID: null,
        PRDIDX: null,
        ITEMS_DETAIL: null,
        SKUIDX: null,
        PRICE: null,
        QTY: null,
        PR_UNIT: null,
        EXC_RATE: null,
        AMOUNT: null,
        OLD_AMOUNT: null,
        DF_AMT_THB: null,
        DF_PRICE_THB: null,
        BGIDX: null,
        REMARK: null,
        PR_BRANDID: null,
        PR_DEPARTID: null,
        D_LOC_NAME: null,
        D_LOC: null,
        D_LOC_CODE: null,
        BUDGETP_CODE: null,
        BUDGETP_NAME: null,
      });
    }

    return () => {};
  }, [productAdd, headerId]);

  const handleModalClose = () => {
    setOpenModal(false);
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const sumTotal = (field, value) => {
    return _.sumBy(field, _.partial(_.sumBy, value));
  };

  const handleCancel = () => {
    setProductItems({
      PRHIDX: null,
      CURR_ID: null,
      PRDIDX: null,
      ITEMS_DETAIL: null,
      SKUIDX: null,
      PRICE: null,
      QTY: null,
      PR_UNIT: null,
      EXC_RATE: null,
      AMOUNT: null,
      OLD_AMOUNT: null,
      DF_AMT_THB: null,
      DF_PRICE_THB: null,
      BGIDX: null,
      REMARK: null,
      PR_BRANDID: null,
      PR_DEPARTID: null,
      D_LOC_NAME: null,
      D_LOC: null,
      D_LOC_CODE: null,
      BUDGETP_CODE: null,
      BUDGETP_NAME: null,
    });
    setFormState("Add");
  };

  const clearSupplier = (rowData) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Confirm to clear to ${rowData.SUPNAME}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, clear it!",
    }).then((result) => {
      if (result.value) {
        let data = {
          SUPCODE: null,
          SUPNAME: null,
        };
        dispatch(addSupplier(rowData.PRDIDX, data, headerId));
      }
    });
  };

  const renderSupplierModal = useCallback(() => {
    return (
      <SupplierModal
        open={openSupploerModal}
        handleAdd={(value) => {
          let data = {
            SUPCODE: value.SUPCODE,
            SUPNAME: value.NAMETHAI,
          };
          dispatch(addSupplier(detailId, data, headerId));
        }}
        handleClose={() => setOpenSupploerModal(false)}
      />
    );
  }, [openSupploerModal]);

  const hasDeleteStatus = (data, status) => {
    if (data.PR_STATUS !== undefined) {
      return status.some((s) => data.PR_STATUS === s);
    }
  };

  const renderTotal = () => {
    if (purchaseRequestDetails.isLoading || purchaseRequesteExpense.isLoading) {
      return (
        <>
          <LinearProgress color="secondary" />
        </>
      );
    }

    const totalPrice =
      sumTotal(["AMOUNT"], purchaseRequestDetails.data) +
      purchaseRequesteExpense.data.AMOUNT;

    return (
      <>
        <Box display="flex" flexGrow={1}>
          <Box marginLeft={1}>
            {isAllowed(authorizePR.data, ["can_add_expense"]) && (
              <Button
                variant="contained"
                onClick={(e) => {
                  e.preventDefault();
                  history.push(`/purchase-expense-edit/${headerId}`);
                }}
                className={classes.buttonAddExpense}
                disabled={
                  Boolean(!purchaseRequestDetails.data) ||
                  (purchaseRequest.data.PR_STATUS >= 20 ? true : false)
                }
              >
                <LocalAtmIcon />
                Expense
              </Button>
            )}
          </Box>
        </Box>
        <Box display="flex" justifyContent="space-between">
          <Box marginLeft={1}>
            <Alert icon={false} variant="outlined" severity="success">
              <Typography variant="h5" component="h2">
                Total Expense :{" "}
                {currencyJS(purchaseRequesteExpense.data.AMOUNT, {
                  precision: 4,
                  symbol: "",
                }).format()}
              </Typography>
            </Alert>
          </Box>
          <Box marginLeft={1} marginRight={1}>
            <Alert icon={false} variant="outlined" severity="success">
              <Typography variant="h5" component="h2">
                Total Price :{" "}
                {currencyJS(totalPrice, {
                  precision: 4,
                  symbol: "",
                }).format()}
              </Typography>
            </Alert>
          </Box>
        </Box>
      </>
    );
  };

  const renderLookupCurrencise = () => {
    if (currencies.data) {
      let obj = currencies.data.reduce(function (acc, cur, i) {
        acc[cur.CURRENCY_ID] = cur.CURRENCY_EXC_CODE;
        return acc;
      }, {});

      return obj;
    }

    return {};
  };

  const renderLookupDepartment = () => {
    if (allDepartments.data) {
      let obj = allDepartments.data.reduce(function (acc, cur, i) {
        acc[cur.REF_ID] = cur.REF_NAME;
        return acc;
      }, {});

      return obj;
    }

    return {};
  };

  const renderLookupBrand = () => {
    if (allBrands.data) {
      let obj = allBrands.data.reduce(function (acc, cur, i) {
        acc[cur.REF_ID] = cur.REF_NAME;
        return acc;
      }, {});

      return obj;
    }

    return {};
  };

  const inputOptionsProject = new Promise(function (resolve) {
    // get your data and pass it to resolve()
    if (projects.data) {
      let obj = projects.data.reduce(function (acc, cur, i) {
        acc[cur.BUDGETP_CODE] = cur.BUDGETP_NAME;
        return acc;
      }, {});

      resolve(obj);
    }
    resolve({});
  });

  const handleAddItemModal = (value) => {
    setActualBudgetBalance(value.ACTUAL_BUDGET_BALANCE);

    if (value.BUDGETP_ID > 0) {
      Swal.fire({
        icon: "question",
        title: "Please select the project.",
        input: "select",
        inputOptions: inputOptionsProject,
        showCancelButton: true,
      }).then((result) => {
        const [BUDGETP_NAME] = _.filter(projects.data, {
          BUDGETP_CODE: result.value,
        }).map((r) => r.BUDGETP_NAME);
        if (result.isConfirmed) {
          setProductItems({
            ...productItems,
            PRHIDX: headerId,
            ITEMS_DETAIL: value.NAME_TH,
            SKUIDX: value.SKUIDX,
            BUDGET_CODE: value.ACC_CODE,
            BUDGETP_CODE: result.value,
            BGIDX: value.BGIDX,
            PR_BRANDID: value.BUDGETS_BRAND,
            PR_DEPARTID: value.BUDGETS_DEPARTMENT,
            PR_UNIT: value.UNIT_NAME,
          });
        }
      });
    } else {
      setProductItems({
        ...productItems,
        PRHIDX: headerId,
        ITEMS_DETAIL: value.NAME_TH,
        SKUIDX: value.SKUIDX,
        BUDGET_CODE: value.ACC_CODE,
        BGIDX: value.BGIDX,
        PR_BRANDID: value.BUDGETS_BRAND,
        PR_DEPARTID: value.BUDGETS_DEPARTMENT,
        PR_UNIT: value.UNIT_NAME,
        BUDGETP_CODE: null,
      });
    }
  };

  const handleAddItem = (value) => {
    headerData.PR_DEPARTID = departid;
    headerData.PR_BRANDID = brandid;
    headerData.PR_YEAR = year;
    headerData.PR_COMPIDX = companyid;
    headerData.PR_CURRENCY = currencyid;
    headerData.PR_COUNTRY_NAME = country;
    headerData.EMAIL = email;

    delete headerData.CREATED_DATE;
    delete headerData.APPROVE_DATE;
    delete headerData.CHECK_DATE;

    value.AMOUNT = parseFloat(parseFloat(value.AMOUNT).toFixed(4));

    if (purchaseRequestDetails.data.length > 0) {
      const result = _.find(purchaseRequestDetails.data, {
        CURR_ID: value.CURR_ID,
      });
      if (result) {
        dispatch(
          addProduct(
            value,
            departid,
            brandid,
            year,
            companyid,
            status,
            headerData
          )
        ).then(() => {
          setFormState("Add");
        });
      } else {
        Swal.fire({
          icon: "warning",
          title: "Warning",
          text: "Single currency per PR is allowed.",
        });
      }
    } else {
      dispatch(
        addProduct(
          value,
          departid,
          brandid,
          year,
          companyid,
          status,
          headerData
        )
      );
    }
  };

  const handleDelete = (value) => {
    const { PRDIDX } = value;
    dispatch(deleteProduct(PRDIDX)).then(() => {
      Swal.fire(
        "Deleted!",
        `${value.ITEMS_DETAIL} has been deleted.`,
        "success"
      ).then(() => {
        dispatch(getPurchaseDetails(headerId));
      });
    });
  };

  const handleEdit = (value) => {
    value.OLD_AMOUNT = value.AMOUNT;
    setProductItems(value);
    setFormState("Update");
  };

  if (purchaseRequestDetails.isRejected) {
    return (
      <Alert severity="error">
        <AlertTitle>Error</AlertTitle>
        This is an error alert — <strong>Get the item data!</strong>
      </Alert>
    );
  }

  if (purchaseRequesteExpense.isRejected) {
    return (
      <Alert severity="error">
        <AlertTitle>Error</AlertTitle>
        This is an error alert — <strong>Get Purchase request expense!</strong>
      </Alert>
    );
  }

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          {purchaseRequest.data &&
            purchaseRequest.data.PR_TYPE !== 2 &&
            purchaseRequest.data.PR_STATUS < 20 && (
              <Box border={1} p={2}>
                <ItemFormComponent
                  headerId={headerId}
                  budget={actualBudgetBalance}
                  valueForm={productItems ? productItems : null}
                  handleOpenModal={handleOpenModal}
                  handleAddItem={handleAddItem}
                  handleCancel={handleCancel}
                  formState={formState}
                  countryid={countryid}
                  department={departid}
                  year={year}
                  status={purchaseRequest.data.PR_STATUS}
                />
              </Box>
            )}
          <br />
          <MaterialTable
            title
            columns={[
              {
                title: "No",
                render: (rowData) => rowData.tableData.id + 1,
              },
              {
                title: "Budget Code",
                field: "BUDGET_CODE",
              },
              {
                title: "Budget Name",
                field: "BUDGET_NAME",
              },
              {
                title: "Project Code",
                field: "BUDGETP_CODE",
              },
              {
                title: "Project Name",
                field: "BUDGETP_NAME",
              },
              {
                title: "Item Name",
                field: "ITEMS_DETAIL",
              },
              {
                title: "Item Code",
                field: "ITEM_CODE",
              },
              {
                title: "Brand",
                field: "PR_BRANDID",
                lookup: renderLookupBrand(),
              },
              {
                title: "Department",
                field: "PR_DEPARTID",
                lookup: renderLookupDepartment(),
              },
              {
                title: "Price",
                field: "PRICE",
                render: (rowData) =>
                  currencyJS(rowData.PRICE, {
                    symbol: "",
                    precision: 4,
                  }).format(),
              },
              {
                title: "Currency",
                field: "CURR_ID",
                lookup: renderLookupCurrencise(),
              },
              {
                title: "QTY",
                field: "QTY",
              },
              {
                title: "Unit",
                field: "PR_UNIT",
              },
              {
                title: "Supplier",
                field: "SUPNAME",
                width: "40ch",
                render: (rowData) => {
                  if (!rowData.SUPCODE) {
                    return;
                  }

                  return (
                    <Box display="flex">
                      <Box flexGrow={1}>{rowData.SUPNAME}</Box>
                      {isAllowed(authorizePR.data, ["can_delete_supplier"]) &&
                        hasDeleteStatus(purchaseRequest.data, [10]) && (
                          <Box>
                            <ClearIcon
                              style={{
                                color: "red",
                              }}
                              onClick={(e) => {
                                e.preventDefault();
                                clearSupplier(rowData);
                              }}
                            />
                          </Box>
                        )}
                    </Box>
                  );
                },
              },
              {
                title: "Original Amount",
                field: "PRICE",
                render: (rowData) => {
                  let result = _.find(currencies.data, {
                    CURRENCY_ID: currencyid,
                  });
                  let originalCurrency = 0;
                  if (result) {
                    originalCurrency = result.CURRENCY_EXC_ID;
                  }
                  return currencyJS(
                    originalCurrency * rowData.PRICE * rowData.QTY,
                    {
                      symbol: "",
                      precision: 4,
                    }
                  ).format();
                },
              },
              {
                title: "Budget Amount",
                field: "AMOUNT",
                render: (rowData) =>
                  currencyJS(rowData.AMOUNT, {
                    symbol: "",
                    precision: 4,
                  }).format(),
              },
              {
                title: "Delivery Location",
                field: "D_LOC_CODE",
              },
              {
                title: "Delivery Location",
                field: "D_LOC",
                hidden: true,
              },
              {
                title: "Delivery Location",
                field: "D_LOC_NAME",
                hidden: true,
              },
            ]}
            data={purchaseRequestDetails.data}
            isLoading={purchaseRequestDetails.isLoading}
            actions={[
              (rowData) => ({
                icon: "comment",
                tooltip: "Add remark",
                onClick: (event, rowData) => {
                  event.preventDefault();
                  history.push(
                    `/purchase-requisition-detail-remark/${rowData.PRDIDX}`
                  );
                },
                hidden: !isAllowed(authorizePR.data, ["can_view_remark"]),
              }),
              (rowData) => ({
                icon: "person",
                tooltip: "Add supplier",
                onClick: (event, rowData) => {
                  event.preventDefault();
                  setDetailId(rowData.PRDIDX);
                  setOpenSupploerModal(true);
                },
                disabled:
                  purchaseRequest.data.PR_STATUS >= 20 ||
                  purchaseRequest.data.PR_TYPE === 2
                    ? true
                    : false,
                hidden: !isAllowed(authorizePR.data, ["can_add_supplier"]),
              }),
              {
                icon: "edit",
                tooltip: "Edit Data",
                onClick: (event, rowData) => {
                  event.preventDefault();
                  handleEdit(rowData);
                },
                disabled:
                  purchaseRequest.data.PR_STATUS >= 20 ||
                  purchaseRequest.data.PR_TYPE === 2
                    ? true
                    : false,
                hidden: !isAllowed(authorizePR.data, ["can_edit_item"]),
              },
              {
                icon: "delete",
                tooltip: "Delete Data",
                onClick: (event, rowData) => {
                  event.preventDefault();
                  Swal.fire({
                    title: "Are you sure?",
                    text: `Confirm to delete to ${rowData.ITEMS_DETAIL}`,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Yes, delete it!",
                  }).then((result) => {
                    if (result.value) {
                      handleDelete(rowData);
                    }
                  });
                },
                disabled:
                  purchaseRequest.data.PR_STATUS >= 20 ||
                  purchaseRequest.data.PR_TYPE === 2
                    ? true
                    : false,
                hidden: !isAllowed(authorizePR.data, ["can_delete_item"]),
              },
            ]}
            options={
              isAllowed(authorizePR.data, [
                "can_view_remark",
                "can_delete_item",
                "can_edit_item",
                "can_add_supplier",
              ])
                ? actionTableAllow
                : actionTableNotAllow
            }
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <Box display="flex" component="div" justifyContent="space-between">
            {renderTotal()}
          </Box>
        </Grid>
      </Grid>
      <ProductItemModal
        open={openModal}
        handleClose={handleModalClose}
        isLoading={products.isLoading}
        handleAdd={handleAddItemModal}
      />
      <ExpenseModalComponent
        headerId={headerId}
        openModal={openExpenseModal}
        handleCloseModal={() => {
          setOpenExpenseModal(false);
        }}
      />
      {renderSupplierModal()}
    </>
  );
};

export default PurchaseItemTableComponent;
